export class FormFieldState {
    state: boolean | null = null;
    message: string = '';
    rules: any = [];
}
